import { I18nNamespace } from 'constants/i18n.const';
import { useModal } from 'hooks/useModal';
import { useNewPhotoLifeCycleStep } from 'hooks/useNewPhotoLifeCycleStep';
import { useTranslation } from 'hooks/useTranslation';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useQrTransactionImage() {
  const { t } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const { openConfirmModal, closeConfirmModal } = useModal();
  const navigate = useNavigate();
  const { getNextPath } = useNewPhotoLifeCycleStep();
  const handleNext = useCallback(
    () =>
      openConfirmModal({
        content: `${t('common:scanQrEndConfirm')}`,
        PrevButtonProps: { children: t('common:cancel') },
        NextButtonProps: { children: t('common:continue') },
        duration: 30000,
        isUseTimer: true,
        isTimerInBtnNext: true,
        onOk: () => {
          closeConfirmModal?.();
          navigate(getNextPath() || '');
        },
        onTimeUp: () => {
          closeConfirmModal();
          navigate(getNextPath() || '');
        },
        onClose: () => {
          closeConfirmModal();
        },
      }),
    [closeConfirmModal, getNextPath, navigate, openConfirmModal, t],
  );

  return {
    handleNext,
  };
}
